/* ResolvedView.tsx generated by @compiled/babel-plugin v0.35.0 */
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./ResolvedView.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect, useMemo, useState } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { ActionName, ElementName, SmartLinkPosition, SmartLinkStatus } from '../../../constants';
import FlexibleCard from '../../FlexibleCard';
import { FooterBlock, MetadataBlock, PreviewBlock, SnippetBlock, TitleBlock } from '../../FlexibleCard/components/blocks';
import ResolvedViewOld from './ResolvedViewOld';
import { FlexibleCardUiOptions, getSimulatedBetterMetadata, PreviewBlockOptions, titleBlockOptions } from './utils';
import { withFlexibleUIBlockCardStyle } from './utils/withFlexibleUIBlockCardStyle';
var titleBlockCss = null;
var footerBlockCss = null;
var metadataBlockCss = null;

/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */
var ResolvedView = function ResolvedView(_ref) {
  var cardState = _ref.cardState,
    onClick = _ref.onClick,
    onError = _ref.onError,
    onResolve = _ref.onResolve,
    actionOptions = _ref.actionOptions,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-block-resolved-view' : _ref$testId,
    url = _ref.url;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPreviewBlockErrored = _useState2[0],
    setIsPreviewBlockErrored = _useState2[1];
  useEffect(function () {
    setIsPreviewBlockErrored(false);
  }, [url, cardState]);
  var _getSimulatedBetterMe = getSimulatedBetterMetadata(cardState.details),
    titleMetadata = _getSimulatedBetterMe.titleMetadata,
    topMetadata = _getSimulatedBetterMe.topMetadata,
    bottomMetadata = _getSimulatedBetterMe.bottomMetadata;
  var footerActions = useMemo(function () {
    return [{
      name: ActionName.FollowAction,
      hideIcon: true
    }, {
      name: ActionName.PreviewAction,
      hideIcon: true
    }, {
      name: ActionName.DownloadAction,
      hideIcon: true
    }];
  }, []);
  return /*#__PURE__*/React.createElement(FlexibleCard, {
    appearance: "block",
    cardState: cardState,
    onClick: onClick,
    onError: onError,
    onResolve: onResolve,
    origin: "smartLinkCard",
    actionOptions: actionOptions,
    testId: testId,
    ui: FlexibleCardUiOptions,
    url: url
  }, /*#__PURE__*/React.createElement(TitleBlock, _extends({}, titleBlockOptions, {
    metadata: titleMetadata,
    subtitle: [{
      name: ElementName.Location
    }],
    metadataPosition: SmartLinkPosition.Top,
    status: SmartLinkStatus.Resolved,
    className: ax(["_zulpcxkx _13mh1pd9"])
  })), /*#__PURE__*/React.createElement(MetadataBlock, {
    primary: topMetadata,
    maxLines: 1,
    status: SmartLinkStatus.Resolved,
    className: ax(["_wwyvidpf _1sxbcxkx _i8d01j6v"])
  }), /*#__PURE__*/React.createElement(SnippetBlock, null), /*#__PURE__*/React.createElement(MetadataBlock, {
    primary: bottomMetadata,
    maxLines: 1,
    status: SmartLinkStatus.Resolved,
    className: ax(["_wwyvidpf _1sxbcxkx _i8d01j6v"])
  }), !isPreviewBlockErrored ? /*#__PURE__*/React.createElement(PreviewBlock, _extends({}, PreviewBlockOptions, {
    onError: function onError() {
      setIsPreviewBlockErrored(true);
    },
    status: SmartLinkStatus.Resolved
  })) : null, /*#__PURE__*/React.createElement(FooterBlock, {
    actions: footerActions,
    status: SmartLinkStatus.Resolved,
    className: ax(["_4t3i1k8s _g0eioxwj _1qryoxwj _sxbroxwj _1gyioxwj"])
  }));
};
var ResolvedViewExported = function ResolvedViewExported(props) {
  if (fg('bandicoots-compiled-migration-smartcard')) {
    return /*#__PURE__*/React.createElement(ResolvedView, props);
  } else {
    return /*#__PURE__*/React.createElement(ResolvedViewOld, props);
  }
};
export default withFlexibleUIBlockCardStyle(ResolvedViewExported);